import React, { useEffect, useMemo, useState } from 'react';

const COUNTRY_CODES = [
  { label: 'United Kingdom', code: '+44', flag: '🇬🇧' },
  { label: 'Nigeria', code: '+234', flag: '🇳🇬' },
  { label: 'United States', code: '+1', flag: '🇺🇸' },
  { label: 'Ghana', code: '+233', flag: '🇬🇭' },
  { label: 'Kenya', code: '+254', flag: '🇰🇪' },
  { label: 'Canada', code: '+1', flag: '🇨🇦' },
];

const defaultCountry = COUNTRY_CODES[0];

export default function PhoneInput({
  value = '',
  onChange = () => {},
  label = 'Phone number',
  required = false,
  wrapperClassName = '',
  selectClassName = '',
  inputClassName = '',
  placeholder = 'Enter number',
  showLabel = true,
}) {
  const [selectedCode, setSelectedCode] = useState(defaultCountry.code);

  useEffect(() => {
    const normalized = (value || '').trim();
    if (!normalized) return;
    const matched = COUNTRY_CODES.find((country) =>
      normalized.startsWith(country.code)
    );
    if (matched) {
      setSelectedCode(matched.code);
    }
  }, [value]);

  const normalizedDigits = useMemo(() => (value || '').replace(/\D/g, ''), [value]);
  const selectedDigitsPrefix = selectedCode.replace('+', '');
  const localDigits = normalizedDigits.startsWith(selectedDigitsPrefix)
    ? normalizedDigits.slice(selectedDigitsPrefix.length)
    : normalizedDigits;

  const handleCountryChange = (event) => {
    const nextCode = event.target.value;
    setSelectedCode(nextCode);
    onChange(
      localDigits ? `${nextCode}${localDigits}` : ''
    );
  };

  const handleNumberChange = (event) => {
    const sanitized = event.target.value.replace(/\D/g, '');
    if (!sanitized) {
      onChange('');
      return;
    }
    onChange(`${selectedCode}${sanitized}`);
  };

  return (
    <label className={`flex flex-col gap-1 text-sm text-slate-300 ${wrapperClassName}`}>
      <span className="text-[11px] uppercase tracking-[0.3em] text-slate-500">
        {label}
        {required && ' *'}
      </span>
      <div className="flex gap-2">
        <select
          value={selectedCode}
          onChange={handleCountryChange}
          className={`rounded-2xl border border-slate-800 bg-slate-950 px-3 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 ${selectClassName}`}
        >
          {COUNTRY_CODES.map((country) => (
            <option key={country.code} value={country.code}>
              {country.flag}
              {showLabel ? ` ${country.label}` : ''}
              {` ${country.code}`}
            </option>
          ))}
        </select>
        <input
          type="tel"
          value={localDigits}
          onChange={handleNumberChange}
          placeholder={placeholder}
          className={`flex-1 rounded-2xl border border-slate-800 bg-slate-950 px-3 py-2 text-sm text-white placeholder:text-slate-500 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 ${inputClassName}`}
        />
      </div>
    </label>
  );
}
